import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import * as langtype from "../redux/actions/LanguageList";
import { getActiveLang, splitLangPath, withLang } from '../utils/language';

const LanguageToggle = ({ LanguageListing }) => {

    const dispatch = useDispatch();
    const [selectedLanguage, setSelectedLanguage] = useState(getActiveLang());

    const handleClick = (lang) => {
        if (lang !== 'en' && lang !== 'ori') return;
        if (lang === getActiveLang()) return;

        localStorage.setItem('lang', lang);
        dispatch(langtype.setLanguage(lang));

        const barePath = splitLangPath(window.location.pathname).path;
        window.location.assign(withLang(barePath, lang));
    };

    useEffect(() => {
        const savedLang = getActiveLang();
        setSelectedLanguage(savedLang);
        dispatch(langtype.setLanguage(savedLang));
    }, [dispatch]);

    return (
        <>
            <div className="language-toggle">
                {LanguageListing && LanguageListing.map((item) => (
                    <button
                        key={item.name}
                        className={`toggle-btn ${selectedLanguage === item.name ? 'active' : ''}`}
                        onClick={() => handleClick(item.name)}
                    >
                        {item.name == "ori" ? "ଓଡି" : "EN"}
                    </button>
                ))}
            </div>
        </>
    )
}

export default LanguageToggle